export default "__VITE_ASSET__BvvPdNQm__"